import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import Card from 'ui/atoms/Card/Card'
import ModuleHeader from 'ui/components/ModuleHeader/ModuleHeader'
import View from 'ui/components/View/View'
import ImpersonateUserList from './components/ImpersonateUserList'

export default function ImpersonateUsersView(): ReactElement {
  const { t } = useTranslation()
  return (
    <View header={<ModuleHeader infoHeader={t('Impersonate users')} />}>
      <Card title={t('Non super users to impersonate')}>
        <ImpersonateUserList />
      </Card>
    </View>
  )
}
